export const assetUrl = (url: string): string => {
  if (process.env.NODE_ENV === 'development') {
    return `/app/assets${url}`;
  }

  return `${process.env.PUBLIC_URL}/assets${url}`;
};
